import ConfirmEmailPendingPage from "./ConfirmEmailPendingPage";

export default ConfirmEmailPendingPage;